// HM-303: re-export delle sole icone Lucide utilizzate nel design system
// SPEC v2.6. Centralizzare riduce import drift e facilita lo swap di set
// icone se in futuro si cambia libreria.
//
// Stroke width default: 1.75px (impostabile per istanza via prop strokeWidth).

export {
  // Sidebar
  LayoutDashboard,
  CalendarDays,
  BookOpenCheck,
  Users,
  Wallet,
  TrendingUp,
  UtensilsCrossed,
  Cpu,
  Settings2,
  // Stati camere
  CircleCheck,
  CalendarClock,
  BedDouble,
  Sparkles,
  TriangleAlert,
  Wind,
  // Azioni comuni
  Plus,
  Pencil,
  Trash2,
  Search,
  Filter,
  Download,
  Printer,
  RefreshCw,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  X,
  Check,
  Bell,
  UserCircle,
  LogOut,
  // Ulteriori usate nei moduli (anticipate per evitare drift)
  Menu,
  Zap,
  Upload,
  ArrowUp,
  ArrowDown,
  // HM-310.r: aggiunte per dashboard reference v2.6
  LogIn,
  MessageCircle,
  Wrench,
  Banknote,
  Clock,
  // HM-347 cluster 16.1.5: card pagamento walk-in + Step 4 recap actions.
  CreditCard,
  AlertTriangle,
  Phone,
  Mail,
  IdCard,
  // HM-495 Schedina Alloggiati Questura: voce sidebar (documento ufficiale).
  FileText,
  // F2-c gestione hotel owner: header struttura, accesso/PIN, copia credenziali.
  Building2,
  KeyRound,
  Copy,
  Save,
  MapPin,
} from 'lucide-react';

export type { LucideIcon, LucideProps } from 'lucide-react';

export const HM_ICON_STROKE_WIDTH = 1.75;
